<template>
<div class="chapter">
<div class="inner_page">
<div id="Title">
<div class="author"><a id="page_2"></a><a id="page_3">BRUNO FULIGNI</a></div><a id="page_3">
<div class="author2">Illustrations by François Moreno</div>
<div class="title">ATLAS</div>
<div class="title1">of</div>
<div class="title2">EXTRATERRESTRIAL ZONES</div>
<div class="pub"><img alt="image" src="images/pub.jpg"/></div>
</a></div><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?146f009a